import React, {useState,useContext} from "react";
import { MODAL_TYPE } from "../../constants/Constants";
import AvailableResource from "../../pages/AccountAndSettings/AvailableResource/AvailableResource";
import AlertSuccessModal from "../AlertSuccessModal/AlertSuccessModal";
import loaderContext from "../../context/loader/LoaderContext";
import ThemePreference from "../../pages/AccountAndSettings/ThemePreference/ThemePreference";

const GlobalModal = (props) => {

    const { hideAlertModal } = useContext(loaderContext);

    const {type,isError,isWarning,isSuccess,heading,description} = props.showModal;

    switch(true){
        case type===MODAL_TYPE.AVAILABLE_NOW: 
            return <AvailableResource />

        case type===MODAL_TYPE.ALERT_MODAL:
            return <AlertSuccessModal
                    isError={isError}
                    isWarning={isWarning}
                    isSuccess={isSuccess}
                    heading={heading}
                    description={description}
                    hideModal={hideAlertModal}
          />
        case type===MODAL_TYPE.THEME_PREFERENCE:
            return <ThemePreference />
        default:
            return <></>
    }
}

export default GlobalModal;